import { type MCPServerInfo } from '../../types';

const GoogleGmailServer: MCPServerInfo = {
  serverId: 'GOOGLE_GMAIL',
  name: 'Gmail',
  slug: 'google-gmail',
  description:
    'Gmail MCP Server for searching, reading, sending, and managing email messages, threads, and labels',
  source: {
    sourceType: 'REPOSITORY',
    type: 'NATOMA',
    repositoryUrl: 'https://github.com/natomalabs/google-mcp-servers',
    commitSha: 'ada3d0c5',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  },
  annotations: {
    hintPreRegistered: true
  }
};

export default GoogleGmailServer;
